// import  image from '../assets/integrationAssests/ppl-logo.png'
export const Gradients = [
  'linear-gradient(326deg, #bd4f6c 0%, #d7816a 74%)',
  'linear-gradient(315deg, #f8ceec 0%, #a88beb 74%)',
  'linear-gradient(315deg, #abe9cd 0%, #3eadcf 74%)',
  'linear-gradient(315deg, #d5adc8 0%, #ff8489 74%)',
  'linear-gradient(315deg, #7f53ac 0%, #647dee 74%)',
  'linear-gradient(315deg, #1fd1f9 0%, #b621fe 74%)',
  'linear-gradient(315deg, #734ae8 0%, #89d4cf 74%)',
  'linear-gradient(315deg, #fc9842 0%, #fe5f75 74%)',
  'linear-gradient(315deg, #fc5296 0%, #f67062 74%)',
  'linear-gradient(315deg, #f907fc 0%, #05d6d9 74%)',
  'linear-gradient(315deg, #f9484a 0%, #fbd72b 74%)',
  'linear-gradient(315deg, #c7e9fb 0%, #e61d8c 74%)'
]

export const GetGradientFromId = id => {
  const gradientsLength = Gradients.length
  if (['number', 'string'].indexOf(typeof id) < 0) {
    const value = Math.floor(Math.random() * gradientsLength)
    return Gradients[value % gradientsLength]
  }
  return Gradients[Number(id) % gradientsLength]
}

export const PLAN_FREE = 'free'
export const PLAN_EDUCATION = 'education'
export const PLAN_INDIVIDUAL = 'individual'
export const PLAN_PRO = 'pro'
export const PLAN_PRO_UNLIMITED = 'prounlimited'

export const STORAGE_LIMITS = {
  [PLAN_FREE]: {
    amount: 2 * 1024 * 1024 * 1024,
    label: '2GB'
  },
  [PLAN_INDIVIDUAL]: {
    amount: 1024 * 1024 * 1024 * 1024,
    label: '1TB'
  },
  [PLAN_PRO]: {
    amount: 1024 * 1024 * 1024 * 1024 * 3,
    label: '3TB'
  }
}

export const PLAN_NAMES = {
  [PLAN_FREE]: 'Free',
  [PLAN_INDIVIDUAL]: 'Lite',
  [PLAN_PRO]: 'Pro',
  [PLAN_PRO_UNLIMITED]: 'Pro Unlimited'
}

export const PLAN_PRICES = {
  [PLAN_FREE]: '$0',
  [PLAN_INDIVIDUAL]: '$13.99',
  [PLAN_PRO]: '$19.99',
  [PLAN_PRO_UNLIMITED]: '$49.99'
}

export const PLAN_CHANGES = {
  [PLAN_FREE]: {
    [PLAN_INDIVIDUAL]: true,
    [PLAN_PRO]: true,
    [PLAN_PRO_UNLIMITED]: true
  },
  [PLAN_INDIVIDUAL]: {
    [PLAN_FREE]: false,
    [PLAN_PRO]: true,
    [PLAN_PRO_UNLIMITED]: true
  },
  [PLAN_PRO]: {
    [PLAN_FREE]: false,
    [PLAN_INDIVIDUAL]: false,
    [PLAN_PRO_UNLIMITED]: true
  },
  [PLAN_PRO_UNLIMITED]: {
    [PLAN_FREE]: false,
    [PLAN_INDIVIDUAL]: false,
    [PLAN_PRO]: false
  }
}

export const IntegrationsContent = [
  {
    title: 'PPL',
    logoImage: require('../assets/integrationAssests/ppl-logo.png'),
    text: `PPL licences recorded music in the UK when it is played
    in public or broadcast and ensures that revenue flows back to
     our members. These include independent and major record companies,
     together with performers ranging from emerging musicians to globally
      renowned artists. In 2020 we collected £225.7 million while also
      distributing money to over 135,000 performers and recording rights holders.`,
    link: 'https://www.ppluk.com',
    detailsText: `Go to your ‘My Party’ page within your account.
     If you are a PPL member, select PPL in the CMO dropdown list.
      This will open a window that is integrated with PPL’s
       technology and allows VEVA to authenticate a performer’s
        identification, retrieve their IPN from PPL’s database
         and add it to your party. Then, anywhere you attribute
          your credit, the metadata will include
    your IPN number, which is verified against PPL’s database,
    allowing for proper credit for all of your recordings.`,
    checkBoxText: null
  },
  {
    title: 'SoundExchange',
    logoImage: require('../assets/integrationAssests/sound-exchange-logo.png'),
    text: `SoundExchange is the premier music tech organization on a mission
    to power the future of music. It was independently formed in 2003 to build
     a fairer, simpler, and more efficient music industry through technology,
     data, and advocacy. The only organization designated by the U.S. government
      to administer the Section 114 sound recording license, SoundExchange collects
       and distributes digital performance royalties on behalf of 560,000 music
       creators and growing. Through proprietary music tech solutions that turn
       data into accurate revenue, SoundExchange has paid more than $9 billion
        in distributions to date`,
    link: 'https://www.soundexchange.com',
    detailsText: `In this integrations section of your profile,
     click the button to consent to send your data to SoundExchange.
      For all of your projects, within your recording - designate if
       anyone should be listed as Featured by selecting F in the F/NF/O
        (F=Featured / NF= Non-Featured / O = Other) parameter.
        Once all of your credits have been added to your recording,
        click the Lock Credit button in the top section of your project.
         SoundExchange will then appear as a tag, and a RIN file is
         automatically sent to SoundExchange containing the credits
          for the specific project.`,
    checkBoxText: `By clicking this box, I hereby authorize
    VEVA Sound to share with SoundExchange, Inc. any recording,
     song, and credit information that I have provided VEVA Sound.`
  },
]
export const Colors = {
  $accent: '#d5743e',
  $white: '#fff',
  $defaultRegionColor: 'rgba(255, 255, 255, 0.1)',
  $selectedRegionColor: 'rgba(75, 181, 67, 0.2)',
}
export const Urls = {
  profileImageUrl: process.env.REACT_APP_IMAGE_URL + 'profile-images/'
}

export const MIN_WIDTH_CUSTOM_DOWNLOAD_PAGE_IMG = '1200px';
